import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';

@Component({
  selector: 'app-button-loading',
  templateUrl: './button-loading.component.html',
  styleUrls: ['./button-loading.component.scss']
})
export class ButtonLoadingComponent implements OnInit, OnChanges {
  @Input() label: string;
  @Input() disabled = false;

  @Input() loading = false;

  _disabled = false;

  @Output() onClick = new EventEmitter();

  constructor() {
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.loading) {
      if (this.loading) {
        this._disabled = true;
      } else {
        this._disabled = false;
      }
    }
  }

}
